import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export function formatDateTime(iso: string | null | undefined): string {
  return iso ? dayjs(iso).format('DD MMM YYYY, HH:mm') : '—';
}

export function formatDate(iso: string | null | undefined): string {
  return iso ? dayjs(iso).format('DD MMM YYYY') : '—';
}

export function fromNow(iso: string | null | undefined): string {
  return iso ? dayjs(iso).fromNow() : '—';
}

/** `YYYY-MM-DD` business date → `07 Oct 2026`. */
export function formatBusinessDate(value: string | null | undefined): string {
  return value ? dayjs(value).format('DD MMM YYYY') : '—';
}

export function toBusinessDate(date: Date | string | null): string | null {
  return date ? dayjs(date).format('YYYY-MM-DD') : null;
}

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const first = parts[0]?.[0] ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '';
  return (first + last).toUpperCase() || '?';
}

export function pluralize(count: number, singular: string, plural = `${singular}s`): string {
  return `${count} ${count === 1 ? singular : plural}`;
}
